export default __webpack_public_path__ + "static/tech-tester-og-0406857526a758eb4fbb335b7f570305.jpg";